"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
var Banner = (function (_super) {
    __extends(Banner, _super);
    function Banner(props) {
        var _this = _super.call(this, props) || this;
        _this.clickClose = _this.clickClose.bind(_this);
        return _this;
    }
    Banner.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.timeout && !isNaN(parseFloat(this.props.timeout.toString())) && isFinite(this.props.timeout)) {
            setTimeout(function () {
                _this.props.onRemove(_this.props);
            }, this.props.timeout);
        }
    };
    Banner.prototype.clickClose = function (e) {
        this.props.onRemove(this.props);
    };
    Banner.prototype.render = function () {
        var iconName;
        switch (this.props.bannerType) {
            case 'error':
                iconName = 'error_circle2';
                break;
            case 'success':
                iconName = 'check_mark_circle2';
                break;
            case 'warn':
                iconName = 'warning_circle2';
                break;
            case 'info':
                iconName = 'information_circle2';
                break;
            default:
                iconName = 'close';
                break;
        }
        var icon = React.createElement(Icon_1.Icon, { icon: iconName });
        var type = this.props.bannerType;
        var style = this.props.bannerStyle ? this.props.bannerStyle : 'standard';
        var bannerCSS = classNames({
            'col-lg-offset-3': true,
            'col-lg-6': true,
            'row': true,
            'alert': true,
            'alert-danger': type === 'error' && style === 'standard',
            'alert-danger-discrete': type === 'error' && style === 'discrete',
            'alert-success': type === 'success' && style === 'standard',
            'alert-success-discrete': type === 'success' && style === 'discrete',
            'alert-warning': type === 'warn' && style === 'standard',
            'alert-warning-discrete': type === 'warn' && style === 'discrete',
            'alert-info': type === 'info' && style === 'standard',
            'alert-info-discrete': type === 'info' && style === 'discrete',
            'alert-dismissible': true
        });
        return (React.createElement("div", { className: 'row col-lg-12', id: this.props.id, style: { position: 'relative', zIndex: 10000 } },
            React.createElement("div", { className: bannerCSS, role: 'alert', style: { paddingLeft: 12, position: 'absolute' } },
                React.createElement("button", { type: 'button', className: 'close', onClick: this.clickClose },
                    React.createElement("span", { "aria-hidden": 'true' }, "\u00D7")),
                React.createElement("div", { className: 'col-lg-1', style: { paddingLeft: 0 } }, icon),
                React.createElement("div", { className: 'col-lg-10 span10 text-center' }, this.props.children))));
    };
    return Banner;
}(React.Component));
exports.Banner = Banner;
//# sourceMappingURL=Banner.js.map